export function removeLoadingScreen() {
  const initialLoader = document.getElementById('initial-loading');

  if (!initialLoader) {
    console.warn("Loader not found, exiting...")
    return;
  }

  initialLoader.classList.toggle('fadeOut');

  if (!('remove' in Element.prototype)) {
    initialLoader.parentNode.removeChild(initialLoader);
  } else {
    initialLoader.remove();
  }
}

// Why 600ms? Nobody knows, but things bork without this delay.
export function removeLoadingScreenAfterDelay(delay = 600) {
  setTimeout(() => {
    removeLoadingScreen()
  }, delay);
}